function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 25",
  transform: "translate(-920 -1364)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 3",
  cx: 41,
  cy: 40,
  rx: 41,
  ry: 40,
  transform: "translate(920 1364)",
  fill: "#f490ac"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-check-double",
  d: "M986.217 1396.569l-4.01-3.623a2.606 2.606 0 00-3.433 0l-24.25 21.914-11.28-10.2a2.606 2.606 0 00-3.433 0l-4.02 3.63a2.052 2.052 0 000 3.111l17.011 15.381a2.606 2.606 0 003.433 0l29.972-27.1a2.059 2.059 0 00.01-3.113zm-32.836 9.699a1.73 1.73 0 002.288 0l21.06-19.051a1.371 1.371 0 000-2.068l-4.577-4.144a1.73 1.73 0 00-2.288 0l-15.34 13.862-5.61-5.078a1.73 1.73 0 00-2.288 0l-4.587 4.145a1.371 1.371 0 000 2.068z",
  fill: "#f9d0dc"
}));
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 80"
  }, props), _ref);
};
export default SvgCheckIcon;